module.exports = __webpack_public_path__ + "img/tcds.cd89c527.png";